import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=162a76fe&"
import script from "./PaymentDetail.vue?vue&type=script&lang=ts&"
export * from "./PaymentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports